import React from 'react';
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import {dateDDMMYY} from "../../../../utils/formatters/Date";
import NumberFormat from "react-number-format";
import {price, rate} from "../../../../utils/formatters/Numbers";
import {Divider} from "@material-ui/core";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";

const UpdateOrderBorrower = ({ ...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <TitlePage title='Prestatario \ Solicitud de Valores \ Editar Postura'/>
                    </Grid>
                    <Grid item xs={3}>
                        <Grid container spacing={1} justify="flex-end">
                            <Grid item>
                                <Button label="Cerrar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button label="Actualizar Postura" onClick={props.editOrderBorrower}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <div className="p-col-12">
                        <Divider/>
                    </div>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <SubtitleLabel header={props.orderBorrower.emisora}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                                <NumberFormat name="cantidad"
                                              value={props.orderBorrower.cantidad}
                                              thousandSeparator={true}
                                              onChange={props.saveDataOrderBorrower}
                                              allowNegative={false}
                                              maxLength={17}
                                              required={true}
                                              decimalScale={0}
                                              fixedDecimalScale={false}
                                              placeholder="Ex: 99,99"
                                              customInput={InputText}
                                              tabIndex={1}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <SubtitleLabel header={rate(props.orderBorrower.tasa * 100)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <SubtitleLabel header={props.orderBorrower.plazo}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <SubtitleLabel header={rate(props.orderBorrower.sobreTasa * 100)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Vence" isBold={true}/>
                                <SubtitleLabel header={dateDDMMYY(props.maturityDate)}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={price(props.orderBorrower.precio)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel header={calculateAmount(props.orderBorrower.precio, props.orderBorrower.cantidad)}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel header={calculateReward(
                                    props.orderBorrower.precio,
                                    props.orderBorrower.cantidad,
                                    (props.orderBorrower.tasa * 100),
                                    props.orderBorrower.plazo)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Valor:" isBold={true}/>
                                <SubtitleLabel header={dateDDMMYY(props.orderBorrower.fecValor)}/>
                            </div>
                            <div className="p-col-12 p-md-12 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Vigencia:" isBold={true}/>
                                <SubtitleLabel header={props.orderBorrower.tipoVigencia === '0' ? 'Diaria' : 'Semanal'}/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (UpdateOrderBorrower);